export const DEAL_SCREEN_EXPERIENCE = {
    BASE: 'base',
    DEAL_CENTRAL: 'dealCentral',
    DEAL_CENTRAL_WITH_FNI: 'dealCentralWithFnI',
    MV_LITE: 'mvLite'
};
